<template>
    <div @focusout="handleFocusOut" tabindex="0">
        <div class="select" :class="selectClass" :id="selectId">
            <div class="select-styled" :class="{ 'active': showDropdown }" @click="toggleDropdown">
                {{ selectedLabel }}
            </div>

            <ul class="select-options" v-bind:style="{ display: showDropdown ? 'block' : 'none' }">
                <li rel="none" :value="key" v-for="(option, key) in options" @click="setOption(key)">{{ option }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CustomSelect',

    props: {
        options:     {
            type:     Object,
            required: true
        },
        selected:    {
            required: true
        },
        selectClass: {
            type: String
        },
        selectId:    {
            type: String
        },
    },

    watch: {
        options:  function () {
            this.selectedLabel = this.options[this.selected]
        },
        selected: function (val) {
            this.selectedLabel = this.options[val]
        }
    },

    mounted () {
        this.selectedLabel = this.options[this.selected]
    },

    data () {
        return {
            showDropdown:  false,
            selectedLabel: ''
        }
    },

    methods: {
        handleFocusOut () {
            this.showDropdown = false
        },

        setOption (key) {
            this.toggleDropdown()
            this.$emit('changed', key)
        },

        toggleDropdown () {
            this.showDropdown = !this.showDropdown
        }
    },
}
</script>
